"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
var react_1 = require("react");
var HeaderRender_1 = __importDefault(require("./HeaderRender"));
var localization_1 = require("@scuf/localization");
var translations_1 = __importDefault(require("./translations"));
var Item_1 = __importDefault(require("./Item/Item"));
var Search_1 = __importDefault(require("./Search/Search"));
var IconItem_1 = __importDefault(require("./IconItem/IconItem"));
var UserProfile_1 = __importDefault(require("./UserProfile/UserProfile"));
var AppLauncher_1 = __importDefault(require("./AppLauncher/AppLauncher"));
var NotificationCenter_1 = __importDefault(require("./NotificationCenter/NotificationCenter"));
/**
 * The Header is the top bar where the hamburger menu, the Honeywell logo (or "HONEYWELL FORGE"), and App or SBG title live. Typically, it will be viewable from all pages, and contains other components that need to be accessible from any page, such as important links, a Search bar for the entire site, or a UserProfile component.
 * @child ./Item/Item.tsx
 * @child ./Search/Search.tsx
 * @child ./IconItem/IconItem.tsx
 * @child ./UserProfile/UserProfile.tsx
 * @child ./AppLauncher/AppLauncher.tsx
 * @child ./NotificationCenter/NotificationCenter.tsx
 */
var Header = /** @class */ (function (_super) {
    __extends(Header, _super);
    function Header() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Header.prototype.render = function () {
        return React.createElement(localization_1.LocalizationProvider, { translations: translations_1.default },
            React.createElement(HeaderRender_1.default, __assign({}, this.props)));
    };
    Header.defaultProps = {
        responsive: true,
        menu: true,
        logo: true,
        isForge: false
    };
    Header.Item = Item_1.default;
    Header.Search = Search_1.default;
    Header.IconItem = IconItem_1.default;
    Header.AppLauncher = AppLauncher_1.default;
    Header.UserProfile = UserProfile_1.default;
    Header.NotificationCenter = NotificationCenter_1.default;
    return Header;
}(react_1.Component));
exports.default = Header;
